// Angular library
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

// Local library
import { CommonFacade, SessionService } from '@amwager/data-access';
import {
  CardDatePipe,
  CardNamePipe,
  CardNumEndPipe,
  IsEmptyPipe,
  LoadService,
  UnsubscribeObservableService
} from '@amwager/util';
import { FundingFacade, IDebitCreditCard } from '@amwager/funding/data-access';
import { AccountFacade } from '@amwager/account/data-access';

// Ionic library
import { AlertController, IonIcon } from '@ionic/angular/standalone';
import * as _ from 'lodash';

// Third party
import { Observable, Subscription, of, takeUntil } from 'rxjs';
import { forEach } from 'lodash';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let EprotectIframeClient: any;
declare let iframeIsReady: boolean;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let callbackDataResponse: any;
let showErrorMsg: string;

@Component({
  selector: 'feature-ion-withdraw-debit-credit-card',
  templateUrl: './debit-credit-card.component.html',
  styleUrls: ['./debit-credit-card.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
    ReactiveFormsModule,
    IsEmptyPipe,
    CardNamePipe,
    CardDatePipe,
    CardNumEndPipe
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DebitCreditCardComponent
  extends UnsubscribeObservableService implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private eProtectiframeClient: any;
  private subsGetCardResponse!: Subscription;
  private tmsId?: string;
  private subsWithdrawCardResponse!: Subscription;

  showAddCard: boolean = false;
  debitAndCreditCardForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.debitAndCreditCardForm?.controls }

  $invervalIframeIsReady!: Subscription;
  $isEProtectURLLoaded!: Subscription;
  isIFrameReady: boolean = false;
  showErrorMsg = '';
  isEProtectURLLoaded: boolean = false;
  orderId?: string;
  cards$!: Observable<IDebitCreditCard[]>;
  showCardList = false;
  amount!: number;
  total!: number;
  isWithDrawing = false;
  cardContentHTMList!: HTMLElement[];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly sessionService: SessionService,
    private readonly loadService: LoadService,
    private readonly fundingFacade: FundingFacade,
    private readonly accountFacade: AccountFacade,
    private readonly elementRef: ElementRef,
    // private readonly datePipe: DatePipe,
    private readonly cdRef: ChangeDetectorRef,
    private readonly commonFacade: CommonFacade,
    private readonly alertCtrl: AlertController,
    private readonly router: Router,
  ) {
    super();
  }

  ngOnInit() {
    // this.loadCDNs();
    this.observerTmsIds();
    this.initForm();
    // this.formVal['amount']?.setValue(25);
    // this.amount = 25;
    this.total = this.amount;

    this.fundingFacade.getDebitCreditCard();
    // this.fundingFacade.isGetDebitCreditCardSuccess$().subscribe(res=>console.log(res));
    this.subsGetCardResponse = this.fundingFacade.getListCards$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((response) => {
      if (response !== undefined) {
        const cards = response.filter((card: { Type: string; }) => card.Type === 'VI');
        this.cards$ = of(cards);
        this.showCardList = true;

        // set default card
        setTimeout(()=>{
          this.cardContentHTMList = this.elementRef.nativeElement.querySelectorAll(
            '.section-card-content .card-list-container .card-per-row'
          );

          _.forEach(this.cardContentHTMList, (html: HTMLElement, index: number) => {
            if (index === 0) {
              this.orderId = cards[0]?.OrderId || 0;
              html.classList.add('active');
            }
          });
        }, 200);
      }
      // this.subsGetCardResponse?.unsubscribe();
      this.cdRef.markForCheck();
    });

  }

  private observerTmsIds(): void {
    this.commonFacade?.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  chooseAmount(amount: number): void {
    this.formVal['amount']?.setValue(amount);
    this.amount = amount;

    this.total = this.amount;
  }

  private initForm(): void {
    this.debitAndCreditCardForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.minLength(25), Validators.maxLength(500)]]
    });
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chooseCard($event: any, method: string, card: string, orderId: string): void {

    const cardRows = this.elementRef.nativeElement.querySelectorAll(
      '.card-per-row'
    );
    cardRows.forEach((cardRow: HTMLElement) => {
      cardRow.classList.remove('active');
    });

    // const creditCard = $event.target as HTMLElement;
    const creditCard = this.elementRef.nativeElement.querySelector(
      '.card-content .card-list-container #'
      + card
      + '.card-per-row'
    );

    this.total = this.amount;

    // if (creditCard.classList.contains('selector')) {
      if (creditCard.classList.contains('active')) {
        creditCard.classList.remove('active');
        this.orderId = '';

        this.total = this.amount;
      }
      else {
        creditCard.classList.add('active');
        this.orderId = orderId;
      }
    // }
  }

  withdrawAmount(): void {
    this.amount = this.formVal['amount']?.value;
    this.total = this.amount;
  }

  withdraw(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('DebitCreditCardComponent:withdraw', false);
      return;
    }

    if (this.debitAndCreditCardForm.valid && this.amount && this.orderId && this.tmsId) {
      this.isWithDrawing = true;

      this.fundingFacade.withdrawDebitCreditCard(
        this.amount,
        this.orderId,
        this.tmsId
      );
      this.subsWithdrawCardResponse = this.fundingFacade.isWithdrawDebitCreditCardSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response) {

          // Temporary update balance if specific error meet.
          if (
            response.error.Error
              ===
            'Unknown Error - Please retry, if you receive this error multiple times please contact support.'
          ) {
            this.showAlertMessage('Successful Withdrawal', 'Successfully Withdraw Amount');
            this.accountFacade.getBalance("WagerEffects:withdrawDebitCredit");
            this.debitAndCreditCardForm.reset();
          }
          else if (response.error.Message)
            this.showAlertMessage('Withdraw Error', response.error.Message);
          else
            this.showAlertMessage('Withdraw Error', response.error.Error);

          this.isWithDrawing = false;
          this.cdRef.markForCheck();
        }

        // this.isWithDrawing = false;
        // this.cdRef.markForCheck();

        this.subsWithdrawCardResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Withdrawal', 'Successfully Withdraw Amount');
          this.debitAndCreditCardForm.reset();
          this.isWithDrawing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.debitAndCreditCardForm);
    }
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
